import React from 'react';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, ColumnSeries, Category, Tooltip, Legend, RangeColorSettingsDirective, RangeColorSettingDirective } from '@syncfusion/ej2-react-charts';

import { colorMappingData, ColorMappingPrimaryXAxis, ColorMappingPrimaryYAxis, rangeColorMapping, listColor } from '../../data/dummy';
import { Header } from '../../components';
import { useStateContext } from '../../contexts/ContextProvider';

const ColorMapping = () => {
  const { currentMode } = useStateContext();

  return (
    <div className='m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl'>
      <Header category='Color Mapping' title='USA Temperatures' />
      <div className="w-full">
        <ChartComponent id='charts' primaryXAxis={ColorMappingPrimaryXAxis} primaryYAxis={ColorMappingPrimaryYAxis} legendSettings={{ mode: 'Range', background: 'white',visible: true, toggleVisibility: false }}
          chartArea={{ border: { width: 0 }}} tooltip={{ enable: true }} background={currentMode === 'Dark' ? '#33373E' : '#fff'} selectionMode='Point' >
          <Inject services={[ ColumnSeries, Legend, Tooltip, Category ]} />
          <SeriesCollectionDirective>
            <SeriesDirective  dataSource={colorMappingData} name="USA" xName="x" yName="y" type="Column" cornerRadius={{ topLeft: 10, topRight: 10, }} >
            </SeriesDirective>
          </SeriesCollectionDirective>
          <RangeColorSettingsDirective>
            {rangeColorMapping.map((item, index) => <RangeColorSettingDirective key={index} {...item.colors} />)} 
            {/* <RangeColorSettingDirective label="1°C to 10°C" start={1} end={10} colors='#FFFF99'></RangeColorSettingDirective>
            <RangeColorSettingDirective label="11°C to 20°C" start={11} end={20} colors='#FFA500'></RangeColorSettingDirective>
            <RangeColorSettingDirective label="21°C to 30°C" start={21} end={30} colors='#FF4040'></RangeColorSettingDirective>   */}
          </RangeColorSettingsDirective>
        </ChartComponent>
      </div>   
    </div> 
  )
}

export default ColorMapping